/**
 * A sortable table header cell (CC_05 Block 4). Clicking toggles the sort on its
 * column and shows the ▲/▼ indicator. Shared by every RYFE table (files,
 * library, lists) so sorting looks and behaves the same everywhere.
 */

import "./ryfe.scss";

export const SortableTh = ({
  sortKey,
  label,
  toggle,
  indicator,
}: {
  sortKey: string;
  label: string;
  toggle: (key: string) => void;
  indicator: (key: string) => string;
}) => (
  <th className="ryfe-th--sortable">
    <button
      type="button"
      className="ryfe-th__btn"
      onClick={() => toggle(sortKey)}
      title="Nach dieser Spalte sortieren"
    >
      {label}
      <span className="ryfe-th__ind">{indicator(sortKey)}</span>
    </button>
  </th>
);
